import { ModelBase } from '../../core/models/model-base.model';

export class Role extends ModelBase {

  constructor(obj?: any) {
    super(obj);
  }
}
